import React from 'react';
import { Link } from "MWC";
import "../less/main.less"

export default function tpl() {

    const isMobile = this.isViewportMobile(),
        { links } = this.props,
        content = links.map((item, index) => {
            return (<div className="breadcrumb-item" key={index}>
                <Link href={item.link}>
                    {this.l10n(item.title)}
                </Link>
            </div >)
        });

    return (
        <section className="breadcrumbs">
            {content}
        </section>
    )
}
